@if (finance) {
  <ion-item>
    <ion-label>Asistent obdrží</ion-label>
    <ul>
      @for (a of finance.assistants; track a) {
        <li>{{ a.fullname }}: {{ a.sum }} Kč</li>
      }
    </ul>
  </ion-item>
  <ion-item>
    <ion-label>Klient zaplatí</ion-label>
    {{ finance.clientSum }} Kč
  </ion-item>
}
